import { useState, useEffect } from 'react'
import { supabase } from '../lib/supabase'
import { SUBJECTS } from '../lib/constants'
import { calculateNextReview, getTodayDate } from '../lib/utils'

export default function ReviewQueue({ userId }) {
  const [queue, setQueue] = useState([])
  const [loading, setLoading] = useState(true)
  const today = getTodayDate()

  useEffect(() => {
    fetchQueue()
  }, [userId])

  const fetchQueue = async () => {
    setLoading(true)
    const { data, error } = await supabase
      .from('gaokao_knowledge_points')
      .select('*')
      .eq('user_id', userId)
      .lte('next_review_at', today)
      .order('next_review_at')

    if (!error) setQueue(data || [])
    setLoading(false)
  }

  const handleReview = async (id, quality) => {
    const item = queue.find(q => q.id === id)
    if (!item) return

    const newInterval = calculateNextReview(item.review_count, quality)
    const nextDate = new Date()
    nextDate.setDate(nextDate.getDate() + newInterval)

    const { data, error } = await supabase
      .from('gaokao_knowledge_points')
      .update({
        last_reviewed_at: new Date().toISOString(),
        next_review_at: nextDate.toISOString(),
        review_count: item.review_count + 1,
        mastery_level: Math.min(5, item.mastery_level + (quality >= 3 ? 1 : -1)),
      })
      .eq('id', id)
      .select()
      .single()

    if (!error && data) {
      setQueue(prev => prev.filter(q => q.id !== id))
    }
  }

  return (
    <div className="max-w-3xl mx-auto p-4">
      <div className="mb-6">
        <h1 className="text-2xl font-bold">今日遗复</h1>
        <p className="text-sm text-ink-500 dark:text-ink-300 mt-1">
          今天有 {queue.length} 个知识点需要复习
        </p>
      </div>

      {loading ? (
        <div className="text-center py-12 text-ink-500">加载中...</div>
      ) : queue.length === 0 ? (
        <div className="card p-8 text-center">
          <p className="text-ink-500">今天没有需要复习的知识点 🎉</p>
          <p className="text-sm text-ink-500 mt-2">去错题本录入新错题吧</p>
        </div>
      ) : (
        <div className="space-y-4">
          {queue.map(item => (
            <div key={item.id} className="card p-5">
              <div className="flex items-center gap-2 mb-2">
                <span
                  className="text-xs px-2 py-0.5 rounded-full text-white"
                  style={{ backgroundColor: SUBJECTS.find(s => s.id === item.subject)?.color }}
                >
                  {item.subject}
                </span>
                <span className="text-xs text-ink-500">
                  已复习 {item.review_count} 次 · 掌握度 {item.mastery_level}/5
                </span>
              </div>
              <h3 className="text-lg font-medium mb-4">{item.name}</h3>
              <div className="flex gap-2 flex-wrap">
                <button
                  onClick={() => handleReview(item.id, 1)}
                  className="btn-ghost text-sm border border-red-300 text-red-600"
                >
                  忘了
                </button>
                <button
                  onClick={() => handleReview(item.id, 3)}
                  className="btn-ghost text-sm border border-yellow-300 text-yellow-600"
                >
                  勉强
                </button>
                <button
                  onClick={() => handleReview(item.id, 5)}
                  className="btn-ghost text-sm border border-green-300 text-green-600"
                >
                  掌握
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  )
}
